// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Empty_wrapper__3p_gS","large":"Empty_large__1sNOp"};